<template>
  <div style="width: 100%; min-width: 1200px;" class="flex-content">
    <!--审核后的工作台-->
    <div
      v-if="isCertified && isSubscribeService"
      style="width: 100%;background: #F5F5F5;"
    >
      <div class="operate-box">
        <span class="company-name">{{ companyName }}</span>
      </div>

      <user />
      <div class="content-box">
        <div class="left-content">
          <to-do-list />
          <project v-if="true" />
        </div>
        <div class="right-content">
          <fast-operate />
          <jxic-document v-if="isJxicPurchaser" />
          <system-information />
          <notice />
        </div>
      </div>
      <membership-service />
    </div>

    <!--未认证的审核状态页面-->
    <enterprise-cert-status
      v-else-if="!isCertified"
      :is-enterprise-page="false"
    />

    <!--企业已认证，未开通服务的展示，历史数据兼容-->
    <service-cert v-else />
  </div>
</template>

<script>
// 组件
import FastOperate from '@/views/home/components/FastOperate'
import MembershipService from '@/views/home/components/MembershipService'
import Notice from '@/views/home/components/Notice'
import Project from '@/views/home/components/Project'
import SystemInformation from '@/views/home/components/SystemInformation'
import ToDoList from '@/views/home/components/ToDoList'
import User from '@/views/home/components/User'
import ServiceCert from '@/components/common/Company/ServiceCert'
import EnterpriseCertStatus from '@/components/common/Company/EnterpriseCertStatus'
import JxicDocument from '@/views/home/components/JxicDocument.vue'

import { mapGetters, mapState } from 'vuex'
import { workbenchServiceDict } from '@/dictionary/system'

export default {
  name: 'HomePage',

  components: {
    FastOperate,
    MembershipService,
    Notice,
    Project,
    SystemInformation,
    ToDoList,
    User,
    EnterpriseCertStatus,
    ServiceCert,
    JxicDocument
  },

  data() {
    return {}
  },

  computed: {
    ...mapState('company', [
      'companyName',
      'isCertified',
      'isPurchaser',
      'isAgency',
      'isSupplier'
    ]),
    ...mapState('router', ['currentWorkbench']),
    ...mapGetters('company', ['platformTitle']),

    // 是否开通服务
    isSubscribeService() {
      return this.isPurchaser || this.isAgency || this.isSupplier
    },

    // 是否是省投及其下属企业，且是在采购工作台
    isJxicPurchaser() {
      const isJxic = this.platformTitle === '江西投资集团电子采购平台'
      const isPurchaser =
        this.currentWorkbench === workbenchServiceDict.PURCHASER.value
      return isJxic && isPurchaser
    }
  },

  watch: {},

  methods: {}
}
</script>

<style scoped lang="scss">
.operate-box {
  width: 100%;
  display: flex;
  background: $white-color;
  height: 48px;
  line-height: 48px;
  box-sizing: border-box;

  .company-name {
    font-size: 16px;
    color: $text-color;
    @include text-bold;
    margin-left: 32px;
  }
}
.content-box {
  display: flex;
  align-items: flex-start;

  .left-content {
    width: 60%;
  }
  .right-content {
    width: 40%;
  }
}
</style>
